import { connect } from "react-redux";
import ChangeAssignee from "./goLiveChangeAssignee";
import {fetchPmTicketAssignee} from "services/redux/maintenance/pmTicket/action";

import { bindActionCreators } from "redux";
import {
    getAssigneeList,
    postAssignee
} from "services/redux/brandActivtion/sitesListing/action";
import {postGoLiveAssignee} from "services/redux/maintenance/goLiveSite/action.js"

const mapStateToProps = (state) => ({
    assigneeList: state.baSiteListingReducer.assigneeList,
    pmTicketAssignee: state.pmTicketReducer.pmTicketAssignee,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAssigneeList,
            postAssignee,
            fetchPmTicketAssignee,
            postGoLiveAssignee
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ChangeAssignee);
